import { z } from "zod"

const AverageBalance = z.object({
  averageBalance: z.string(),
})

export function getExistingAverageBalance(data: unknown): string {
  const result = AverageBalance.safeParse(data)
  return result.success ? result.data.averageBalance : ""
}

export function isOnDeckExtraDataValid(data: unknown) {
  return !!getExistingAverageBalance(data)
}
